/**
 * Created by WangJun11 on 2018/8/14.
 */
/**
 * H5分享的data
 */
function getShareData(st) {
    if (!st) {
      return
    }
    let stc = Number(st)
    switch (stc) {
      case 1:
        return {
          title: '全球旅游线路精选'
        }
      default:
  
        break;
    }
  }
  
  /*
   convasKeyId：画布key，
   imageUrl：网络背景图片
   cityName：出发城市
   productTypeName：产品类型
   startPrice：起价
   promotionPrice：已省价格
   satisfaction：满意度
   travelCount：出游人数
  */
  
  const generateLocalImage = (dataDict, completeBlock) => {
    let convasKeyId = dataDict['convasKeyId']
    let imageUrl = dataDict['imageUrl']
    imageUrl = imageUrl.replace(/http:/g,"https:")
    let cityName = dataDict['cityName']
    let productTypeName = dataDict['productTypeName']
    let startPrice = dataDict['startPrice']
    let promotionPrice = dataDict['promotionPrice']
    let satifactionCount = dataDict['satisfaction']
    let travelCount = dataDict['travelCount']
    let isDerivative = dataDict['isDerivative']
    
    let img = new Image();
    img.setAttribute("crossOrigin",'Anonymous')
    img.src = imageUrl;
    img.onload = () => {
        let devicePixelRatio = window.devicePixelRatio;
        let canvas = document.getElementById(convasKeyId);
        canvas.setAttribute('width', 250 * devicePixelRatio);
        canvas.setAttribute('height', 200 * devicePixelRatio);
        let ctx = canvas.getContext('2d');
        let convasHeight = 200
        let convasWidth = 250
        let imgHeight = img.height
        let imgWidth = img.width*200/imgHeight

        ctx.scale(devicePixelRatio, devicePixelRatio);
        //底图
        ctx.drawImage(img, (imgWidth - convasWidth)/2, 0, imgWidth, imgHeight, 0, 0, convasWidth, convasHeight)
        //城市和品类
        drawTopView(ctx, cityName, productTypeName)
        //背景图
        ctx.fillStyle = 'rgba(0,0,0,0.7)'
        ctx.fillRect(0, convasHeight - 60, convasWidth, 60)
        let shadowOriginY = convasHeight - 60
        //价格
        drawPriceView(ctx, shadowOriginY, startPrice, promotionPrice)
        //底部出游人数和满意度
        drawBottomView(ctx, shadowOriginY, satifactionCount, travelCount, isDerivative)
        let shareImg = canvas.toDataURL();
        completeBlock(shareImg);
    }
  }
  
  function drawTopView(ctx, cityName, typeName) {
    let cityNameSize
    if (cityName) {
      ctx.fillStyle = 'rgba(0,0,0,0.7)'
      ctx.textAlign = 'left'
      ctx.font = '13px'
      cityNameSize = compatibleMeasureText(ctx,13,cityName)
      ctx.fillRect(10, 10, cityNameSize.width + 15, 25)
      ctx.fillStyle = 'white'
      ctx.fillText(cityName, 18, 27)
    }
    if (typeName) {
      ctx.fillStyle = '#2dbb55'
      ctx.font = '13px'
      ctx.textAlign = 'left'
      let typeNameSize = compatibleMeasureText(ctx,13,typeName)
      let typeNameLeft = cityName ? cityNameSize.width + 25 : 8
      ctx.fillRect(typeNameLeft, 10, typeNameSize.width + 15, 25)
      ctx.fillStyle = 'white'
      ctx.fillText(typeName, typeNameLeft + 8, 27)
    }
  }
  
  function drawPriceView(ctx, shadowOriginY, priceNum, promotionNum) {
    if (priceNum) {
      ctx.fillStyle = '#ff7733'
      ctx.font = '13px'
      ctx.textAlign = 'left'
      ctx.fillText('¥', 12, shadowOriginY + 25)
      ctx.font = '17px'
      ctx.textAlign = 'left'
      ctx.fillText(priceNum, 21, shadowOriginY + 25)
      ctx.font = '13px'
      let textSize = compatibleMeasureText(ctx,13,priceNum.toString())
      ctx.textAlign = 'left'
      ctx.fillText('起', (33 + textSize.width), shadowOriginY + 25)
    }
    if (promotionNum) {
      let promotionString = '已省 ¥' + promotionNum
      ctx.font = '12px'
      let promotionSize = compatibleMeasureText(ctx,12,promotionString.toString())
      roundRect(ctx, '#ff7733', 95, shadowOriginY + 9, promotionSize.width + 14, 20, 4)
      ctx.fillStyle = 'white'
      ctx.textAlign = 'left'
      ctx.fillText(promotionString, 102, shadowOriginY + 24)
    }
  }
  
  function drawBottomView(ctx, shadowOriginY, satisfaction, travelCount, isDerivative) {
    let satisfaString = '新品上线'
    if (satisfaction > 0) {
      satisfaString = satisfaction + '%满意度' 
    }
    ctx.fillStyle = 'white'
    ctx.textAlign = 'center'
    ctx.font = '13px'
    ctx.fillText(satisfaString, 47, shadowOriginY + 50)
    if (travelCount) {
      let travelString = travelCount + '人出游'
      if (isDerivative) {
        travelString = '已售' + travelCount + '份'
      }
      ctx.fillStyle = 'white'
      ctx.textAlign = 'center'
      ctx.font = '13px'
      ctx.fillText(travelString, 133, shadowOriginY + 50)
    }
  }
  
  function roundRect(ctx, color, x, y, w, h, r) {
    ctx.save()
    // 开始绘制
    ctx.beginPath()
    // 因为边缘描边存在锯齿，最好指定使用 transparent 填充
    ctx.fillStyle = color
    // 左上角
    ctx.arc(x + r, y + r, r, Math.PI, Math.PI * 1.5)
    // border-top
    ctx.moveTo(x + r, y)
    ctx.lineTo(x + w - r, y)
    ctx.lineTo(x + w, y + r)
    // 右上角
    ctx.arc(x + w - r, y + r, r, Math.PI * 1.5, Math.PI * 2)
    // border-right
    ctx.lineTo(x + w, y + h - r)
    ctx.lineTo(x + w - r, y + h)
    // 右下角
    ctx.arc(x + w - r, y + h - r, r, 0, Math.PI * 0.5)
    // border-bottom
    ctx.lineTo(x + r, y + h)
    ctx.lineTo(x, y + h - r)
    // 左下角
    ctx.arc(x + r, y + h - r, r, Math.PI * 0.5, Math.PI)
    // border-left
    ctx.lineTo(x, y + r)
    ctx.lineTo(x + r, y)
    // 这里是使用 fill 还是 stroke都可以，二选一即可，但是需要与上面对应
    ctx.fill()
    ctx.closePath()
    // 剪切
    ctx.clip()
    ctx.restore()
  }
  
  function compatibleMeasureText(ctx,fontSize,string) {
    let stringSize
    if (ctx.measureText) {
      stringSize = ctx.measureText(string)
    }
    else {
      stringSize = {width: string.length*fontSize}
    }
    return stringSize
  }
  
  module.exports = {
    getShareData: getShareData,
    generateLocalImage: generateLocalImage,
  }
  


// WEBPACK FOOTER //
// libs/util/shareConfig.js